export default __webpack_public_path__ + "static/media/icon_outros.bba6540b.svg";